import { gql, useQuery } from '@apollo/client'

export const NOTIFICATION_DEVICES = gql`
  query NotificationDevices {
    notificationDevices {
      hasActiveDevice
    }
  }
`

export interface INotificationDevicesResult {
  notificationDevices: { hasActiveDevice: boolean | null }
}

export const useNotificationDevices = () => {
  const { data } = useQuery<INotificationDevicesResult>(NOTIFICATION_DEVICES)

  return { hasActiveDevice: data?.notificationDevices.hasActiveDevice }
}
